<template>
      <v-container>
        <div class="speed-dial-container">
          <v-btn
            color="blue"
            dark
            fab
            @click="toggleBarcodeInput"
            class="fab-button"
          >
            <v-icon>mdi-qrcode-scan</v-icon>
          </v-btn>
          <v-sheet
            class="v-barcode-sheet"
            v-if=showBarcodeInput
            elevation="13"
            border
            rounded
          >
          <v-text-field
            @keyup.enter="handleBarcodeEnter"
            hide-details
            dense
            placeholder="Enter barcode"
            class="barcode-text-field"
            ref="barcodeInput"
            :error-messages="barcodeError"
          ></v-text-field>
        </v-sheet>
        </div>
      </v-container>
</template>

<script>
export default {
  data() {
    return {
      fab: false,
      transition: 'fade-transition',
      showBarcodeInput: false,
      barcodeError: null,
      openInNewTab: false,
    };
  },
  methods: {
    toggleBarcodeInput() {
      this.showBarcodeInput = !this.showBarcodeInput;
      if (this.showBarcodeInput) {
        this.$nextTick(() => {
          this.$refs.barcodeInput.focus();
          this.$refs.barcodeInput.$el.classList.add('expanded'); // Add expanded class
        });
      } else {
        this.$refs.barcodeInput.$el.classList.remove('expanded'); // Remove expanded class
      }
    },
    handleBarcodeEnter() {
      const barcodeInput = this.$refs.barcodeInput;
      const barcode = barcodeInput ? barcodeInput.$el.querySelector('input').value.trim().toLowerCase() : '';
      this.$refs.barcodeInput.$el.querySelector('input').value = ''; // Clear the input after processing
      this.showBarcodeInput = false;

      if (barcode) {
        let bid = null;

        if (barcode.startsWith('pic-') || barcode.startsWith('πιψ-')) {
          bid = parseInt(barcode.substring(4), 10);
          this.navigateTo('part-info', bid);
        } else if (barcode.startsWith('oic-') || barcode.startsWith('οιψ-')) {
          bid = parseInt(barcode.substring(4), 10);
          this.navigateTo('order-info', bid);
        } else if (barcode.startsWith('rid-') || barcode.startsWith('ριδ-')) {
          bid = parseInt(barcode.substring(4), 10);
          this.$router.push({ name: 'edit-repair', params: { repairId: bid }})
        } else if (barcode.startsWith('http://')) {
          const regex = /^http:\/\/(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}):8080\/part\/(\d+)\/info$/;
          const match = barcode.match(regex);
          if (match) {
            const bid = parseInt(match[2], 10);
            this.navigateTo('part-info', bid);
          } else {
            this.barcodeError = 'Invalid barcode URL format';
          }
        } else {
          bid = parseInt(barcode, 10);
          if (!isNaN(bid)) {
            this.navigateTo('order-info', bid);
          } else {
            this.barcodeError = 'Invalid barcode format';
          }
        }
      }
    },
    navigateTo(routeName, bid) {
        this.$router.push({ name: routeName, params: { id: bid } });
    },
  },
};
</script>
<style>
.speed-dial-container {
  position: fixed;
  bottom: 60px;
  left: 220px;
  z-index: 100;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0; /* Remove the gap */
}

.barcode-text-field {
  width: 0; /* Start with 0 width */
  transition: width 0.3s ease-out; /* Add smooth transition */
}

.barcode-text-field.expanded {
  width: 200px;
}

.v-barcode-sheet {
  margin-left: 0px; /* Add small gap between button and field */
  overflow: hidden; /* Hide overflow during animation */
  transition: all 0.3s ease-out;
  max-width: 0;
}
.barcode-text-field {
  width: 200px; /* Set a default width */
  transition: width 0.3s ease-out;
  font-size: 16px; /* Increase font size */
}

.v-barcode-sheet {
  margin-left: 8px;
  overflow: hidden;
  transition: all 0.3s ease-out;
  max-width: 300px; /* Ensure the sheet can accommodate the text field */
  padding: 10px; /* Add padding to the sheet */
  background-color: #ffffff; /* Ensure the sheet has a contrasting background */
}
.v-barcode-sheet.expanded {
  max-width: 300px;
}

.fab-button {
  flex-shrink: 0;
}
</style>